import React from "react";
import { Radio, RadioChangeEvent } from "antd";
import { Question, QuestionAnswers } from "../../../../Interface/Index";
// import "./index.scss";

interface MCQQuestionProps {
  question: Question;
  questionAnswer: QuestionAnswers;
  handleCheck: (e: RadioChangeEvent) => void;
  isRoundFinished: boolean;
}

const MCQQuestion: React.FC<MCQQuestionProps> = ({
  question,
  handleCheck,
  questionAnswer,
  isRoundFinished,
}) => {
  const questionType = question.type;
  const answer =
    questionType.toLowerCase() === "mcq"
      ? questionAnswer.answer
      : questionAnswer.fileUrl;

  const isDisabled =
    isRoundFinished || (question.responses && question.responses.length > 0);

  const onOptionChange = (e: RadioChangeEvent) => {
    const isSameAnswer = e.target.value === answer;
    if (isSameAnswer) {
      handleCheck({ target: { value: null } } as RadioChangeEvent);
    } else {
      handleCheck(e);
    }
  };

  return (
    <div className="mcq-question">
      <Radio.Group
        onChange={onOptionChange}
        value={answer}
        disabled={isDisabled}
      >
        {question.options?.map((option, index) => (
          <Radio
            key={index}
            value={option.description}
            className="mcq-option"
            checked={answer === option.description}
            onClick={(e) => {
              if (answer === option.description) {
                onOptionChange({ target: { value: null } } as RadioChangeEvent);
              }
            }}
          >
            {option.description}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
};

export default MCQQuestion;
